<div [class]="bannerType" [class.banner]="true" [ngClass]="{ hide: !isShown }">
  <div class="message" [innerHTML]="bannerText"></div>
  <div class="close" (click)="closeBanner()"></div>
</div>
